(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const faqContainer = document.querySelector('.faq-accordion');
  if (!faqContainer) return;

  const paragraphs = faqContainer.querySelectorAll('p');
  const formattedHTML = Array.from(paragraphs).map(p => {
    const text = p.innerHTML.trim();
    const [question, ...answerParts] = text.split('?');
    if (!answerParts.length) return '';

    const answer = answerParts.join('?').trim();

    const iconSVG = `
      <svg class="icon-chevron-down faq__summary-icon" aria-hidden="true" focusable="false" role="presentation"
        xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
        <path class="icon-chevron-down-left" d="M7 6.75L12.5 1.25" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
        <path class="icon-chevron-down-right" d="M7 6.75L1.5 1.25" stroke="currentColor" stroke-width="1.75" stroke-linecap="square"></path>
      </svg>`;

    return `
      <div class="faq-item">
        <button class="faq-question" aria-expanded="false">
          <span>${question}?</span>
          <span class="faq-icon">${iconSVG}</span>
        </button>
        <div class="faq-answer-wrapper">
          <div class="faq-answer">
            <p>${answer}</p>
          </div>
        </div>
      </div>
    `;
  }).join('');

  faqContainer.innerHTML = formattedHTML;

  faqContainer.querySelectorAll('.faq-item').forEach(item => {
    const button = item.querySelector('.faq-question');
    const wrapper = item.querySelector('.faq-answer-wrapper');
    const answer = item.querySelector('.faq-answer');

    button.addEventListener('click', () => {
      const isOpen = item.classList.toggle('active');
      button.setAttribute('aria-expanded', isOpen);

      if (isOpen) {
        const fullHeight = answer.scrollHeight + 20; // Add padding space
        wrapper.style.maxHeight = fullHeight + 'px';
      } else {
        wrapper.style.maxHeight = '0';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
